import * as $ from 'jquery';
import { Component, OnInit, AfterViewInit, ViewChild, ViewEncapsulation, OnDestroy, HostListener } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';

import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { MasterConstants } from './../../../../common/constants/master-constants';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { TotalOrderSummaryService } from './../../../../services/seed/reports/total-order-summary.service';
import { CommonService } from './../../../../services/common/common.service';
import { ExcelService } from './../../../../services/infrastructure/excel.service';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { ConfigService } from './../../../../services/infrastructure/config.service';

import { CommonDDL } from './../../../../models/CommonDDL';
import { TotalOrderSummaryFilter } from './../../../../models/TotalOrderSummaryFilter';
import { ReportType } from '../../../../models/report-type.model';
import { UserReportFilterSliderService } from '../../../../common/components/user-report-filter/user-report-filter-slider.service';
import { Subscription } from 'rxjs';
import { UserFilterColumnDisplayed } from '../../../../models/user-filter-columndisplayed.model';
import { ColumnDescription, UserReportFilter } from '../../../../models/user-report-filter.model';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { UserReportFilterService } from '../../../../services/seed/reports/user-report-filter.service';

@Component({
  selector: 'app-total-order-summary',
  templateUrl: './total-order-summary.component.html',
  styleUrls: ['./total-order-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TotalOrderSummaryComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();
  private readonly originalDisplayedColumns: any[] = [
    { headertxt: "Order Number", columnfield: "orderNumber", className: 'mat-header-cell orderNumber text-center', tdClassName: 'mat-cell orderNoText text-center' },
    { headertxt: "Order Type", columnfield: "orderType", className: 'mat-header-cell orderType text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Item", columnfield: "itemNumber", className: 'mat-header-cell itemNumber text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Product Name", columnfield: "brand", className: 'mat-header-cell itemDescription text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "Description", columnfield: "itemDescription", className: 'mat-header-cell itemDescription text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Equiv Units(BG)", columnfield: "quantity", className: 'mat-header-cell quantity text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "In Progress(Soft+Hard)", columnfield: "inProgressQty", className: 'mat-header-cell inProgressQty text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Shipped/Invoiced", columnfield: "shippedInvoicedQty", className: 'mat-header-cell shippedInvoicedQty text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Left to Process", columnfield: "leftToProcess", className: 'mat-header-cell shippedInvoicedQty text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Left to Invoice", columnfield: "leftToInvoiced", className: 'mat-header-cell inProgressQty text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Long/(Short)", columnfield: "longShort", className: 'mat-header-cell longShort text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "PY GPOS", columnfield: "pY_GPOS", className: 'mat-header-cell longShort text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Desired Delivery Date", columnfield: "desiredDeliveryDate", className: 'mat-header-cell desiredDeliveryDate text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Grower Business Name", columnfield: "growerBusinessName", className: 'mat-header-cell growerBusinessName text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Grower Name", columnfield: "growerName", className: 'mat-header-cell growerName text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "Account", columnfield: "accountNumber", className: 'mat-header-cell accountNumber text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "Account Name", columnfield: "accountName", className: 'mat-header-cell accountName text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "Account City", columnfield: "city", className: 'mat-header-cell city text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "Account State", columnfield: "state", className: 'mat-header-cell state text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "Account Zip", columnfield: "zipCode", className: 'mat-header-cell state text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "Marketing Brand", columnfield: "marketingBrand", className: 'mat-header-cell marketingBrand text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "Product Line", columnfield: "productLine", className: 'mat-header-cell marketingBrand text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "Seed Size", columnfield: "seedSize", className: 'mat-header-cell seedSize text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "Package Size", columnfield: "packageSize", className: 'mat-header-cell packageSize text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "Treatment", columnfield: "treatment", className: 'mat-header-cell itemDescription text-center', tdClassName: 'mat-cell text-center' },
    /*{ headertxt: "DSM", columnfield: "dsm", className: 'mat-header-cell dsm text-center', tdClassName: 'mat-cell text-center' },*/
    { headertxt: "Implementation Specialist", columnfield: "implementationSpecialist", className: 'mat-header-cell dsm text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "Account Manager", columnfield: "accountManager", className: 'mat-header-cell dsm text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "Sales Enablement/CDS", columnfield: "salesEnablement", className: 'mat-header-cell dsm text-center', tdClassName: 'mat-cell text-center pl-0' },
    /*{ headertxt: "RSD", columnfield: "rsd", className: 'mat-header-cell rsd text-center', tdClassName: 'mat-cell text-center' }*/
    { headertxt: "ASM/BU Lead", columnfield: "buLead", className: 'mat-header-cell rsd text-center', tdClassName: 'mat-cell text-center pl-0' },
    { headertxt: "SE/CDS Lead", columnfield: "cdsLead", className: 'mat-header-cell rsd text-center', tdClassName: 'mat-cell text-center pl-0' }
  ];

  private readonly originalColumnsToDisplay: Array<ColumnDescription> = [{ headertxt: 'Product Line', columnfield: 'productLine' }, { headertxt: 'Marketing Brand', columnfield: 'marketingBrand' }, { headertxt: 'Grower Units', columnfield: 'growerUnits' }, { headertxt: 'My Dealer Bucket', columnfield: 'myDealerBucketQty' }, { headertxt: 'Total Grower Units', columnfield: 'totalGrowerUnit' }, { headertxt: 'Long/(Short)', columnfield: 'longShort' }, { headertxt: 'Dealer Units', columnfield: 'dealerUnits' }, { headertxt: 'Total Ordered Units', columnfield: 'shippable' }, { headertxt: 'Shipped/Invoiced', columnfield: 'shippedInvoicedQty' }, { headertxt: 'In Progress', columnfield: 'inProgressQty' }, { headertxt: 'Balance', columnfield: 'leftToProcess' }, { headertxt: 'PY GPOS', columnfield: 'pY_GPOS' }];

  columnsToDisplay: string[];

  public currentFilter = new UserReportFilter();

  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  filterValueList = new Array();
  filterList: any;
  selectedValue: string;
  marketingBrand: string;
  marketingMasterList: any = [];
  seedsizeMasterList: any = [];
  packagesizeMasterList: any = [];
  technologyMasterList: any = [];
  treatmentMasterList: any = [];
  maturityMasterList: any = [];
  productLineMasterList: any = [];
  totalOrderSummaryDataSource: any;
  productTotalOrderSummaryDataSource: any;
  tempDataList: any = [];
  productDataList: any = [];
  headerDS: any[] = this.originalDisplayedColumns;
  productDetailDS: any[] = [];
  isProductSearch = true;
  showProductLineDetail = false;
  showProductDetail = false;
  productName: string;
  OrdersCount: number;
  isEvolveAccountRestriction = false;
  validateEvolveData: any;
  accountNoList: any = [];
  stateMasterList: any = [];
  districtMasterList: any = [];
  orderTypeList: any = [{ id: 'Dealer Order', value: 'Dealer Order' }, { id: 'Grower Order', value: 'Grower Order' }];
  filter: TotalOrderSummaryFilter = new TotalOrderSummaryFilter();
  productNameList: any = [];
  paginatorDS: any[] = [];
  length = 0;
  pageSize = 50;
  pageIndex = 0;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  headerSubscription: any;
  totalOrderSummarySubscription: any;
  impDisplayName: any;
  @ViewChild('productPaginator', { read: MatPaginator }) productPaginator: MatPaginator;
  @ViewChild('productSearchTable', { read: MatSort }) productSearchSort: MatSort;
  @ViewChild('showProductLineTable', { read: MatSort }) showProductLineSort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  searchTypeList: string[] = ['Product Line', 'Marketing Brand', 'Account No', 'Account Name', 'WFU Employee', 'City', 'State/Province'];

  constructor(private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private totalOrderSummaryService: TotalOrderSummaryService,
    private commonService: CommonService,
    private toastrService: ToastrService,
    private excelService: ExcelService,
    private userReportFilterSliderService: UserReportFilterSliderService,
    private userReportFilterService: UserReportFilterService) {
    // set table headers
    this.headerDS = this.originalDisplayedColumns;
    this.columnsToDisplay = this.originalColumnsToDisplay.map(x => x.columnfield);
  }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.WF_Sales_GenericLevel)) {
      const salesGenericLevel = JSON.parse(this.localStorageService.get(MasterConstants.WF_Sales_GenericLevel));
      this.impDisplayName = salesGenericLevel.find(x => x.data == MasterConstants.WF_Impl_SplList_Display).value;
      const columnToUpdate = this.originalDisplayedColumns.find(obj => obj.columnfield === "implementationSpecialist");
      // If the Column is found
      if (columnToUpdate) {
        // Update the column
        columnToUpdate.headertxt = this.impDisplayName;
      }
      this.headerDS = this.originalDisplayedColumns;
      this.columnsToDisplay = this.originalColumnsToDisplay.map(x => x.columnfield);
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    }

    if (this.validateEvolveData != undefined) {
      const sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;
    }

    this.setSearchTypeList();

    this.resetTosFilter();
    this.loadMasterData();

    this.subscription.push(
      this.userReportFilterSliderService.selectedUserFilter.subscribe(filter => {
        if (filter && filter.reportFilter) {
          this.clearAllFilter();

          this.currentFilter = filter;
          const filters: UserFilterColumnDisplayed = JSON.parse(filter.reportFilter);
          this.filterList = filters.filterOption;

          this.columnsToDisplay = filters.displayedColumns.map(x => x.columnfield);

          this.isProductSearch = true;
          this.showProductLineDetail = false;
          this.showProductDetail = false;

          this.getTotalOrderSummary(TOSLevel.Level_0, false);
        }
        else {
          if (filter && filter.filterDescription === this.currentFilter.filterDescription || !filter)
            this.currentFilter = new UserReportFilter();
        }
      }));
  }

  setSearchTypeList() {
    if (this.isProductSearch) {
      this.searchTypeList = ['Product Line', 'Marketing Brand', 'Account No', 'Account Name', 'WFU Employee', 'City', 'State/Province'];
      this.selectedValue = this.searchTypeList[1];
    }
    else if (this.showProductLineDetail) {
      this.searchTypeList = ['Product Line', 'Marketing Brand', 'Product Name', 'Account No', 'Account Name', 'WFU Employee', 'City', 'State/Province'];
      this.selectedValue = this.searchTypeList[2];
    }
    else {
      // for showProductDetail
      this.searchTypeList = ['Product Line', 'Marketing Brand', 'Product Name', 'Order Type', 'Account No', 'Account Name', 'WFU Employee', 'City', 'State/Province', 'Order No', 'Package Size', 'Seed Size', 'Treatment'];
      this.selectedValue = this.searchTypeList[2];
    }
  }

  // Load master data
  loadMasterData() {
    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.ALL_SEED_SIZE_LIST)) {
      this.seedsizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_SEED_SIZE_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST)) {
      this.packagesizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST));
    }

    // Technology master data
    if (this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST)) {
      this.technologyMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.ALL_TREATMENT_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_TREATMENT_LIST));
    }

    // Maturity master data
    if (this.localStorageService.get(MasterConstants.MATURITY_LIST)) {
      this.maturityMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MATURITY_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }

    this.commonService.getReportFilterDDLValues(this.headerYear).subscribe(result => {
      const data = result as CommonDDL;
      this.stateMasterList = data.states;
      this.accountNoList = data.accounts;
      this.districtMasterList = data.distDSM;
      this.marketingMasterList = data.marketingBrand;
    }, error => LolLoggerService.error(error));
  }

  // Reset Audit Filter
  resetTosFilter() {
    this.marketingBrand = null;
    this.productName = null;
    this.isProductSearch = true;
    this.showProductLineDetail = false;
    this.showProductDetail = false;

    this.filterList = {
      'CompanyCode': this.headerCompany,
      'CropYear': this.headerYear,
      'ProductLineList': [],
      'MarketingBrandList': [],
      'AccountNo': [],
      'TxtAccountNo': null,
      'AccountName': null,
      'DistrictList': [],
      'City': null,
      'State': [],
      'Brand': null,
      'OrderId': null,
      'OrderTypeList': [],
      'SeedSizeList': [],
      'PackageSizeList': [],
      'TreatmentList': []
    };

    this.filter = {
      'companyCode': this.headerCompany,
      'cropYear': this.headerYear,
      'productLine': null,
      'marketingBrand': null,
      'account': null,
      'txtAccountNo': null,
      'accountName': null,
      'district': null,
      'city': null,
      'state': null,
      'productName': null,
      'orderNumber': null,
      'orderType': null,
      'seedSize': null,
      'packageSize': null,
      'treatment': null,
      'brandExactMatch': false
    };
  }

  keepFilter(selectedObj: any, type: string) {
    if (!this.validateInputText()) {
      this.toastrService.error('Invalid Input.');
      return false;
    }

    if (this.filterValueList) {
      let selectedIds = '';
      if (selectedObj && selectedObj.selectedValues) {
        const selectedValues = selectedObj.selectedValues as any[];
        selectedValues.forEach(x => { selectedIds = selectedIds + (type == 'AccountNo' ? x.accountNumber : x.id) + ','; });
      }

      switch (type) {
        case 'ProductLine':
          this.filter.productLine = selectedIds;
          break;
        case 'MarketingBrand':
          this.filter.marketingBrand = selectedIds;
          break;
        case 'AccountNo':
          this.filter.account = selectedIds;
          break;
        case 'State':
          this.filter.state = selectedIds;
          break;
        case 'OrderType':
          this.filter.orderType = selectedIds;
          break;
        case 'PackageSize':
          this.filter.packageSize = selectedIds;
        case 'Seedsize':
          this.filter.seedSize = selectedIds;
        case 'Treatment':
          this.filter.treatment = selectedIds;
          break;
      }

      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.filterList) {
        // Product Line
        if (this.filterList.ProductLineList && this.filterList.ProductLineList.length > 0) {
          let strPL = '';
          this.filterList.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));

          selectedIds = '';
          this.productLineMasterList.forEach(x => {
            if (this.filterList.ProductLineList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.productLine = selectedIds;
        }
        else {
          this.filter.productLine = null;
        }

        // Marketing Brand
        if (this.filterList.MarketingBrandList && this.filterList.MarketingBrandList.length > 0) {
          let strMB = '';
          this.filterList.MarketingBrandList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));

          selectedIds = '';
          this.marketingMasterList.forEach(x => {
            if (this.filterList.MarketingBrandList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.marketingBrand = selectedIds;
        }
        else {
          this.filter.marketingBrand = null;
        }

        // text Account No
        if (this.filterList.TxtAccountNo && this.filterList.TxtAccountNo != '') {
          this.filterValueList.push('Account No : ' + this.filterList.TxtAccountNo);
          this.filter.account = this.filterList.TxtAccountNo;
        }
        else if (this.filterList.AccountNo && this.filterList.AccountNo.length > 0) {
          let strAct = '';
          this.filterList.AccountNo.forEach(x => {
            strAct = strAct + x + ', ';
          });
          this.filterValueList.push('Account No : ' + strAct.substr(0, strAct.length - 2));

          this.filter.account = strAct;
        }
        else {
          this.filter.account = null;
        }

        // Account Name
        if (this.filterList.AccountName && this.filterList.AccountName != '') {
          this.filterValueList.push('Account Name : ' + this.filterList.AccountName);
          this.filter.accountName = this.filterList.AccountName;
        }
        else {
          this.filter.accountName = null;
        }

        // District
        if (this.filterList.DistrictList && this.filterList.DistrictList.length > 0) {
          let strDSM = '';
          this.filterList.DistrictList.forEach(x => {
            strDSM = strDSM + x + ', ';
          });
          this.filterValueList.push('WFU Employee : ' + strDSM.substr(0, strDSM.length - 2));

          selectedIds = '';
          this.districtMasterList.forEach(x => {
            if (this.filterList.DistrictList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.district = selectedIds;
        }
        else {
          this.filter.district = null;
        }

        // City
        if (this.filterList.City && this.filterList.City != '') {
          this.filterValueList.push('City : ' + this.filterList.City);
          this.filter.city = this.filterList.City;
        } else {
          this.filter.city = null;
        }

        // State
        if (this.filterList.State && this.filterList.State.length > 0) {
          let strSt = '';
          this.filterList.State.forEach(x => {
            strSt = strSt + x + ', ';
          });
          this.filterValueList.push('State : ' + strSt.substr(0, strSt.length - 2));

          selectedIds = '';
          this.stateMasterList.forEach(x => {
            if (this.filterList.State.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.state = selectedIds;
        } else {
          this.filter.state = null;
        }

        // Brand
        if (this.filterList.Brand && this.filterList.Brand != '') {
          this.filterValueList.push('Product Name : ' + this.filterList.Brand);
          this.filter.productName = this.filterList.Brand;
        }
        else {
          this.filter.productName = null;
        }

        // Order No
        if (this.filterList.OrderId && this.filterList.OrderId != '') {
          this.filterValueList.push('Order No : ' + this.filterList.OrderId);
          this.filter.orderNumber = this.filterList.OrderId;
        } else {
          this.filter.orderNumber = null;
        }

        // Order Type
        if (this.filterList.OrderTypeList && this.filterList.OrderTypeList != '') {
          this.filterValueList.push('Order Type : ' + this.filterList.OrderTypeList);
          this.filter.orderType = this.filterList.OrderTypeList;
        } else {
          this.filter.orderType = null;
        }

        // Package Size
        if (this.filterList.PackageSizeList && this.filterList.PackageSizeList.length > 0) {
          let strPS = '';
          this.filterList.PackageSizeList.forEach(x => {
            strPS = strPS + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strPS.substr(0, strPS.length - 2));
          selectedIds = '';
          this.packagesizeMasterList.forEach(x => {
            if (this.filterList.PackageSizeList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.packageSize = selectedIds;
        }
        else {
          this.filter.packageSize = null;
        }

        // Seed Size
        if (this.filterList.SeedSizeList && this.filterList.SeedSizeList.length > 0) {
          let strSS = '';
          this.filterList.SeedSizeList.forEach(x => {
            strSS = strSS + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strSS.substr(0, strSS.length - 2));

          selectedIds = '';
          this.seedsizeMasterList.forEach(x => {
            if (this.filterList.SeedSizeList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.seedSize = selectedIds;
        }
        else {
          this.filter.seedSize = null;
        }

        // Treatment
        if (this.filterList.TreatmentList && this.filterList.TreatmentList.length > 0) {
          let strTreat = '';
          this.filterList.TreatmentList.forEach(x => {
            strTreat = strTreat + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strTreat.substr(0, strTreat.length - 2));

          selectedIds = '';
          this.treatmentMasterList.forEach(x => {
            if (this.filterList.TreatmentList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.treatment = selectedIds;
        }
        else {
          this.filter.treatment = null;
        }
      }
    }
    this.setAccountTableHeight();
    this.filterList = this.getProductFilters(this.filterList);
  }

  // Get Product filter
  getProductFilters(productFilter) {
    this.filterList.CompanyCode = this.headerCompany;
    this.filterList.CropYear = this.headerYear;
    return productFilter;
  }

  clearAllFilter() {
    this.filterValueList = new Array();
    this.resetTosFilter();

    this.totalOrderSummaryDataSource = new MatTableDataSource([]);
    this.totalOrderSummaryDataSource.paginator = this.productPaginator;
    this.totalOrderSummaryDataSource.sort = this.productSearchSort;

    this.productTotalOrderSummaryDataSource = new MatTableDataSource([]);
    this.productTotalOrderSummaryDataSource.paginator = this.productPaginator;
    this.productTotalOrderSummaryDataSource.sort = this.showProductLineSort;
    this.currentFilter = new UserReportFilter();
    this.userReportFilterSliderService.resetFilter();
    this.productDetailDS = [];
    this.columnsToDisplay = this.originalColumnsToDisplay.map(x => x.columnfield);
    this.setPaginatorDS();
    this.paginator.firstPage();
    this.setAccountTableHeight();
  }

  // Clear filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeTosFilter(filterValue);

      if (this.filterValueList.length < 1) {
        this.totalOrderSummaryDataSource = new MatTableDataSource([]);
        this.totalOrderSummaryDataSource.paginator = this.productPaginator;
        this.totalOrderSummaryDataSource.sort = this.productSearchSort;
      }
      this.setAccountTableHeight();
    }
  }

  //Select filter
  public selectFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filterList,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.TotalOrderSummary, 0, this.originalColumnsToDisplay.map(x => new ColumnDescription(x.columnfield, x.headertxt)), newFilter);
  }

  //Add filter
  public addFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filterList,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.TotalOrderSummary, 1, this.originalColumnsToDisplay.map(x => new ColumnDescription(x.columnfield, x.headertxt)), newFilter);
  }

  public editFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filterList,
      filterValueList: this.filterValueList,
      displayedColumns: this.columnsToDisplay.map(x => this.originalColumnsToDisplay.find(y => y.columnfield === x))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.GrowerOrderAudit, 1, this.originalColumnsToDisplay.map(x => new ColumnDescription(x.columnfield, x.headertxt)), this.currentFilter);
  }

  public save(): void {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filterList,
      filterValueList: this.filterValueList,
      displayedColumns: this.columnsToDisplay.map(x => this.originalColumnsToDisplay.find(y => y.columnfield === x))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    if (this.currentFilter.userReportFilterId) {
      this.userReportFilterService.updateUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      });
    }
    else {
      this.userReportFilterService.addUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      });
    }
  }

  //To remove clear search filter
  removeTosFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Product Line':
        this.filterList.ProductLineList = [];
        this.filter.productLine = null;
        break;
      case 'Marketing Brand':
        this.filterList.MarketingBrandList = [];
        this.filter.marketingBrand = null;
        break;
      case 'Account No':
        if (!this.isEvolveAccountRestriction) {
          this.filterList.TxtAccountNo = null;
        }
        this.filterList.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account Name':
        this.filterList.AccountName = null;
        this.filter.accountName = null;
        break;
      case 'District':
        this.filterList.DistrictList = [];
        this.filter.district = null;
        break;
      case 'City':
        this.filterList.City = null;
        this.filter.city = null;
        break;
      case 'State':
        this.filterList.State = [];
        this.filter.state = null;
        break;
      case 'Product Name':
        this.filterList.Brand = null;
        this.filter.productName = null;
        break;
      case 'Order No':
        this.filterList.OrderId = null;
        this.filter.orderNumber = null;
        break;
      case 'Order Type':
        this.filterList.OrderTypeList = [];
        this.filter.orderType = null;
        break;
      case 'Package Size':
        this.filterList.PackageSizeList = [];
        this.filter.packageSize = null;
        break;
      case 'Seed Size':
        this.filterList.SeedSizeList = [];
        this.filter.seedSize = null;
        break;
      case 'Treatment':
        this.filterList.TreatmentList = [];
        this.filter.treatment = null;
        break;
      default:
        break;
    }
  }

  getTotalOrderSummary(tosLevel = TOSLevel.Level_0, brandExactMatch = false) {
    this.filter.brandExactMatch = brandExactMatch;
    this.keepFilter(null, ' ');
    if (!this.validateInputText()) {
      return false;
    }
    if (this.showProductLineDetail && this.filterList.MarketingBrandList && this.filterList.ProductLineList && (this.filterList.MarketingBrandList.length == 0 || this.filterList.ProductLineList.length == 0)) {
      this.toastrService.error('Filters Marketing Brand and Product Line are needed for search.');
      return false;
    }

    if (this.showProductDetail && this.filterList.MarketingBrandList && this.filterList.ProductLineList && (this.filterList.MarketingBrandList.length == 0 || this.filterList.ProductLineList.length == 0 || this.filterList.Brand == null)) {
      this.toastrService.error('Filters Marketing Brand, Product Name and Product Line are needed for search.');
      return false;
    }
    this.loaderService.setLoaderStatus(true);
    // To do code to get the data for total order summary page

    if (this.showProductLineDetail) { tosLevel = TOSLevel.Level_1; }
    if (this.showProductDetail) { tosLevel = TOSLevel.Level_2; }

    this.totalOrderSummarySubscription = this.totalOrderSummaryService.getTotalOrderSummaryData(tosLevel, this.filter).subscribe((result: any) => {
      if (result) {
        this.tempDataList = result;
        this.totalOrderSummaryDataSource = new MatTableDataSource(this.tempDataList);
        this.totalOrderSummaryDataSource.paginator = this.productPaginator;
        this.totalOrderSummaryDataSource.sort = this.productSearchSort;

        // Code to fill the Product line table data with the first filter of marketing brand and Product line
        if (this.showProductLineDetail) {
          if (this.filterList.MarketingBrandList.length > 0 && this.filterList.ProductLineList.length > 0) {
            let data = [];
            // this.tempDataList.filter(parent => parent.isGroupBy == false); // && parent.marketingBrand == this.filterList.MarketingBrandList[0] && parent.productLine == this.filterList.ProductLineList[0]
            this.tempDataList.forEach(parent => {
              if (!parent.isGroupBy) {
                data = data.concat(parent.orderSummaryList);
              }
            });
            if (data) {
              this.setProductNameTableData(data);
            }
          }
        }

        // Code to fill the Account detail table data
        if (this.showProductDetail) {
          this.productDetailDS = [];
          this.tempDataList.forEach(parent => {
            if (!parent.isGroupBy) {
              parent.orderSummaryList.forEach(child => {
                child.orderSummaryList.forEach(item => {
                  this.productDetailDS.push(item);
                });
              });
            }
          });
          this.length = this.productDetailDS.length;
          this.setPaginatorDS();
          this.paginator.firstPage();
        }
      }
      this.loaderService.setLoaderStatus(false);
    }, (error) => {
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.error(error);
    });
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccountTableHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccountTableHeight();
  }

  // set account table height
  setAccountTableHeight() {
    setTimeout(function () {
      const tableHeight = window.innerHeight - $('.quickSearchTopFilter').outerHeight() - $('.itemAvailText').outerHeight() - $('.orderSummaryPage h3').outerHeight() - $('.breadcrumbRow').outerHeight() - 190;
      $('.orderSummaryTable').css('max-height', tableHeight + 'px');
    }, 100);
  }

  // set account table height
  setCropTableHeight() {
    setTimeout(function () {
      const tableHeight = window.innerHeight - $('.quickSearchTopFilter').outerHeight() - $('.itemAvailText').outerHeight() - $('.orderSummaryPage h3').outerHeight() - $('.breadcrumbRow').outerHeight() - 205;
      $('.marketingBrandTable').css('max-height', tableHeight + 'px');
    }, 100);
  }

  // set account table height
  setOrderTableHeight() {
    setTimeout(function () {
      const tableHeight = window.innerHeight - $('.quickSearchTopFilter').outerHeight() - $('.itemAvailText').outerHeight() - $('.orderSummaryPage h3').outerHeight() - $('.breadcrumbRow').outerHeight() - 205;
      $('.ordersTable').css('max-height', tableHeight + 'px');
    }, 100);
  }

  // Set the data for ProductLine table
  setProductNameTableData(data) {
    this.productNameList = [];
    this.productNameList = data.filter(x => x.isGroupBy == false);

    this.productTotalOrderSummaryDataSource = new MatTableDataSource(this.productNameList);
    this.productTotalOrderSummaryDataSource.paginator = this.productPaginator;
    this.productTotalOrderSummaryDataSource.sort = this.showProductLineSort;
  }

  changeToSearchByProduct($event) {
    if ($event) {
      this.marketingBrand = $event.marketingBrand;
      this.showProductLineDetail = true;
      this.isProductSearch = false;
      this.showProductDetail = false;
      this.setCropTableHeight();

      this.removeCommonTosFilterChip();
      this.addCommonTosFilterChip($event);

      this.setProductNameTableData($event.orderSummaryList);
      this.setSearchTypeList();
      this.getTotalOrderSummary(TOSLevel.Level_1, false);
    }
  }

  changeToProductDetail($event) {
    if ($event) {
      this.showProductLineDetail = false;
      this.isProductSearch = false;
      this.showProductDetail = true;

      this.removeCommonTosFilterChip();
      this.addCommonTosFilterChip($event);

      this.productName = $event.brand;
      this.productDetailDS = [];

      this.OrdersCount = this.productDetailDS.length;
      this.length = this.productDetailDS.length;
      this.setPaginatorDS();
      this.paginator.firstPage();
      this.setSearchTypeList();
      this.getTotalOrderSummary(TOSLevel.Level_2, true);
    }
    this.setOrderTableHeight();
  }

  removeCommonTosFilterChip() {
    // Product Line
    this.filterList.ProductLineList = [];
    this.filter.productLine = null;
    this.removeFilterOptionFromFilterChip('Product Line');

    // Marketing Brand
    this.filterList.MarketingBrandList = [];
    this.filter.marketingBrand = null;
    this.removeFilterOptionFromFilterChip('Marketing Brand');

    if (this.showProductDetail) {
      // Product Name
      this.filterList.Brand = null;
      this.filter.productName = null;
      this.removeFilterOptionFromFilterChip('Product Name');
    }
  }

  addCommonTosFilterChip($event) {
    // Product Line
    this.filter.productLine = $event.productLine + ',';
    this.filterList.ProductLineList = [$event.productLine];
    this.filterValueList.push('Product Line : ' + $event.productLine);

    // Marketing Brand
    this.filter.marketingBrand = $event.marketingBrand + ',';
    this.filterList.MarketingBrandList = [$event.marketingBrand];
    this.filterValueList.push('Marketing Brand : ' + $event.marketingBrand);

    if (this.showProductDetail) {
      // Product Name
      this.filterList.Brand = $event.brand;
      this.filter.productName = $event.brand;
      this.filterValueList.push('Product Name : ' + $event.brand);
    }
  }

  resetFilterOptionsForBreadcrumb() {
    if (this.showProductLineDetail) {
      if (this.filterList) {
        const tempProductLineList = this.filterList.ProductLineList;
        const tempProductLine = this.filter.productLine;
        const tempMarketingBrandList = this.filterList.MarketingBrandList;
        const tempMarketingBrand = this.filter.marketingBrand;

        let strPL = '';
        tempProductLineList.forEach(x => {
          strPL = strPL + x + ', ';
        });

        let strMB = '';
        tempMarketingBrandList.forEach(x => {
          strMB = strMB + x + ', ';
        });

        this.clearAllFilter();

        this.filterList.ProductLineList = tempProductLineList;
        this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));
        this.filter.productLine = tempProductLine;

        this.filterList.MarketingBrandList = tempMarketingBrandList;
        this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
        this.filter.marketingBrand = tempMarketingBrand;
      }
    }
    else {
      this.clearAllFilter();
    }
  }

  removeFilterOptionFromFilterChip(filterType) {
    const tempValue = this.filterValueList.filter(item => item.indexOf(filterType) >= 0);

    const index = this.filterValueList.indexOf(tempValue[0]);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
    }
  }

  revertToIsProductSearch() {
    this.isProductSearch = true;
    this.showProductLineDetail = false;
    this.showProductDetail = false;
    this.resetFilterOptionsForBreadcrumb();
    this.setSearchTypeList();
    this.keepFilter(null, ' ');
    this.getTotalOrderSummary(TOSLevel.Level_0, false);
  }

  revertToIsProductLineSearch() {
    this.isProductSearch = false;
    this.showProductLineDetail = true;
    this.showProductDetail = false;
    this.resetFilterOptionsForBreadcrumb();
    this.setSearchTypeList();
    this.keepFilter(null, ' ');
    this.getTotalOrderSummary(TOSLevel.Level_1, false);
  }

  validateInputText() {
    const accountRegx = RegExp('^[0-9, ]+$');
    const orderIdRegx = RegExp('^[a-zA-Z0-9, ]+$');
    const cityRegx = RegExp('^[a-zA-Z0-9, ]+$');

    return (this.filterList.TxtAccountNo ? accountRegx.test(this.filterList.TxtAccountNo) : true &&
      this.filterList.OrderId ? orderIdRegx.test(this.filterList.OrderId) : true &&
        this.filterList.City ? cityRegx.test(this.filterList.City) : true);
  }

  //Navigate
  onNavigate(url) {
    window.open(url, '_blank');
  }

  //emit row click event
  redirectToOrder(e: any, rowData: any) {
    let orderType, accountNo, orderId;
    orderType = rowData.orderType;
    accountNo = rowData.accountNumber;
    orderId = rowData.orderId;

    if (rowData.clickable && orderType == 'Dealer Order' && accountNo != 0 && orderId != 0) {
      this.onNavigate('/orders/dealer-order-view' + '/0' + '/' + orderId + '/' + accountNo);
    }
    if (rowData.clickable && orderType == 'Grower Order' && accountNo != 0 && orderId != 0) {
      this.onNavigate('/orders/grower-order-detail' + '/0' + '/' + orderId);
    }
  }

  // Table sorting
  sortData(sort: Sort) {
    const data = this.productDetailDS.slice();

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.productDetailDS = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return compare(a[sort.active], b[sort.active], isAsc);
    });

    this.setPaginatorDS();
  }

  // set paginator on change
  setPaginatorDS() {
    const recordToSkip = this.pageSize * this.pageIndex;
    this.paginatorDS = this.productDetailDS.slice(recordToSkip, recordToSkip + this.pageSize);
  }

  // Set MatPaginator Inputs on paginator change
  onPaginatorChange(e: PageEvent) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.setPaginatorDS();
  }

  private autoConvertMapToObject = (map) => {
    const obj = {};
    for (const item of [...map]) {
      const [
        key,
        value
      ] = item;
      obj[key] = value;
    }
    return obj;
  }

  // Code to call the export service and write data to the file name mentioned
  exportResult() {
    this.loaderService.setLoaderStatus(true);
    const excelData = [];
    const headerText = this.columnsToDisplay.map(x => this.originalColumnsToDisplay.find(y => y.columnfield === x).headertxt);

    if (this.isProductSearch) {
      setTimeout(x => {
        if (this.tempDataList && this.tempDataList.length > 0) {
          this.tempDataList.forEach(x => {
            // Don't export SubTotal rows
            const exportData = new Map();

            if (x.isGroupBy == false) {
              headerText.forEach(y => {
                switch (y) {
                  case 'Product Line': {
                    exportData.set(y, x.isGroupBy == false ? x.productLine : 'Sub Total:')
                    break;
                  }
                  case 'Marketing Brand': {
                    exportData.set(y, x.marketingBrand)
                    break;
                  }
                  case 'Grower Units': {
                    exportData.set(y, parseFloat(this.commonService.getFormatedNumber(x.growerUnits, false)))
                    break;
                  }
                  case 'My Dealer Bucket': {
                    exportData.set(y, parseFloat(this.commonService.getFormatedNumber(x.myDealerBucketQty, false)))
                    break;
                  }
                  case 'Total Grower Units': {
                    exportData.set(y, parseFloat(this.commonService.getFormatedNumber(x.totalGrowerUnit, false)))
                    break;
                  }
                  case 'Long/(Short)': {
                    exportData.set(y, parseFloat(this.commonService.getFormatedNumber(x.longShort, false)))
                    break;
                  }
                  case 'Dealer Units': {
                    exportData.set(y, x.dealerUnits)
                    break;
                  }
                  case 'Total Ordered Units': {
                    exportData.set(y, x.shippable)
                    break;
                  }
                  case 'Shipped/Invoiced': {
                    exportData.set(y, x.shippedInvoicedQty)
                    break;
                  }
                  case 'In Progress': {
                    exportData.set(y, x.inProgressQty)
                    break;
                  }
                  case 'Balance': {
                    exportData.set(y, x.leftToProcess)
                    break;
                  }
                  case 'PY GPOS': {
                    exportData.set(y, x.pY_GPOS)
                    break;
                  }
                  default: {
                    break;
                  }
                }
              });

              const obj = this.autoConvertMapToObject(exportData);

              excelData.push(
                obj
              );
            }
          });
          this.excelService.exportAsExcelFile(excelData, 'TOS_MarketingBrand_ProductLine');
        }
        this.loaderService.setLoaderStatus(false);
      }, 100);
    } else if (this.showProductLineDetail) {
      setTimeout(x => {
        if (this.productNameList && this.productNameList.length > 0) {
          this.productNameList.forEach(x => {
            // Don't export SubTotal rows
            const exportData = new Map();

            if (x.isGroupBy == false) {
              headerText.forEach(y => {
                switch (y) {
                  case 'Product Line': {
                    exportData.set(y, x.isGroupBy == false ? x.productLine : 'Sub Total:')
                    break;
                  }
                  case 'Marketing Brand': {
                    exportData.set('Product Name', x.brand)
                    break;
                  }
                  case 'Grower Units': {
                    exportData.set(y, x.growerUnits)
                    break;
                  }
                  case 'My Dealer Bucket': {
                    exportData.set(y, x.myDealerBucketQty)
                    break;
                  }
                  case 'Total Grower Units': {
                    exportData.set(y, x.totalGrowerUnit)
                    break;
                  }
                  case 'Long/(Short)': {
                    exportData.set(y, x.longShort)
                    break;
                  }
                  case 'Dealer Units': {
                    exportData.set(y, x.dealerUnits)
                    break;
                  }
                  case 'Total Ordered Units': {
                    exportData.set(y, x.shippable)
                    break;
                  }
                  case 'Shipped/Invoiced': {
                    exportData.set(y, x.shippedInvoicedQty)
                    break;
                  }
                  case 'In Progress': {
                    exportData.set(y, x.inProgressQty)
                    break;
                  }
                  case 'Balance': {
                    exportData.set(y, x.leftToProcess)
                    break;
                  }
                  case 'PY GPOS': {
                    exportData.set(y, x.pY_GPOS)
                    break;
                  }
                  default: {
                    break;
                  }
                }
              });

              const obj = this.autoConvertMapToObject(exportData);

              excelData.push(
                obj
              );
            }
          });
          this.excelService.exportAsExcelFile(excelData, 'TOS_SummaryByProductName');
        }
        this.loaderService.setLoaderStatus(false);
      }, 100);
    } else if (this.showProductDetail) {
      setTimeout(x => {
        if (this.productDetailDS && this.productDetailDS.length > 0) {
          this.productDetailDS.forEach(x => {
            excelData.push({
              'Order Number': x.orderNumber,
              'Order Type': x.orderType,
              'Item': x.itemNumber,
              'Product Name': x.brand,
              'Description': x.itemDescription,
              'Equiv Units(BG)': x.orderType == 'Dealer Order' ? x.dealerUnits : x.growerUnits,
              'In Progress(Soft+Hard)': x.inProgressQty,
              'Shipped/Invoiced': x.shippedInvoicedQty,
              'Left to Process': x.leftToProcess,
              'Left to Invoice': x.leftToInvoiced,
              'Long/(Short)': x.longShort,
              'PY GPOS': x.pY_GPOS,
              'Desired Delivery Date': x.desiredDeliveryDate,
              'Grower Business Name': x.growerBusinessName,
              'Grower Name': x.growerName,
              'Account': x.accountNumber,
              'Account Name': x.accountName,
              'Account City': x.city,
              'Account State': x.state,
              'Account Zip': x.zipCode,
              'Marketing Brand': x.marketingBrand,
              'Product Line': x.productLine,
              'Seed Size': x.seedSize,
              'Package Size': x.packageSize,
              'Treatment': x.treatment,
              [this.impDisplayName]: x.implAccountName,
              'Account Manager': x.actMgrAccountName,
              'Sales Enablement/CDS': x.salesEnabAccountName,
              'ASM/BU Lead': x.asmLeadAccountName,
              'SE/CDS Lead': x.secdsLeadAccountName
            });
          });
          this.excelService.exportExcel(excelData, 'TOS_OrderDetail_ProductName');
        }
        this.loaderService.setLoaderStatus(false);
      }, 100);
    }
  }

  // Search the account details on shipto / Deliverto dropdown
  filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  ngOnDestroy() {
    if (this.headerSubscription) {
      this.headerSubscription.unsubscribe();
    }

    if (this.totalOrderSummarySubscription) {
      this.totalOrderSummarySubscription.unsubscribe();
    }

    this.userReportFilterSliderService.resetFilter();

    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

enum TOSLevel {
  Level_0 = 0,
  Level_1 = 1,
  Level_2 = 2
}
